




















































































import { defineComponent, ref, watch } from '@nuxtjs/composition-api'

import { RelatedProduct } from './RelatedProducts.vue'

import RelatedCarouselModalSkeleton from '~/components/global/skeletons/RelatedCarouselModalSkeleton.vue'
import Title from '~/components/feature/PDP/Title.vue'
import ApplicationTab from '~/components/feature/PDP/ApplicationTab.vue'
import FigureBlock from '~/components/feature/PDP/FigureBlock.vue'
import SupportingData from '~/components/feature/PDP/SupportingData.vue'
import IconFa6SolidXmark from '~icons/fa6-solid/xmark'

import usePDPAnalytics from '@/composables/analytics/usePDPAnalytics'
import { usePdpStore } from '~/store/pdp'
import { useProductStore } from '~/store/product'
import { componentNameMap } from '~/modules/contentstack/pdpTemplateParser'

export default defineComponent({
  components: {
    Title,
    ApplicationTab,
    FigureBlock,
    SupportingData,
    IconFa6SolidXmark,
    RelatedCarouselModalSkeleton,
  },
  props: {
    productData: {
      type: Object as () => RelatedProduct,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    currentProductIndex: {
      type: Number,
      required: true,
    },
    relatedProductsLength: {
      type: Number,
      required: true,
    },
    citationCount: {
      type: Number,
      required: true,
    },
  },
  emits: ['buttonClick'],
  setup(props) {
    const { trackProductClick } = usePDPAnalytics()
    const pdpStore = usePdpStore()
    const selectedApplicationChiclet = ref<string>()
    const onChicletClick = (application: string) => {
      selectedApplicationChiclet.value = application
    }
    const supportingTableData = ref()
    const fetchingRelatedProductTemplate = ref(false)

    watch(
      () => props.productData,
      async () => {
        selectedApplicationChiclet.value = ''

        // fetch template for related product and set supporting data labels and values based on the related product template
        fetchingRelatedProductTemplate.value = true
        const productType = props.productData.productType
        const productId = props.productData.productId
        await pdpStore.fetchPDPTemplateForRelatedProducts(productId, productType)
        const relatedProductTemplate = pdpStore.relatedProductsTemplates[productId]
        const supportingDataLabels = relatedProductTemplate.rows
          .flatMap((row) => {
            return row.columns.flatMap((column) => {
              return column.components.flat()
            })
          })
          .find((component) => component.name === componentNameMap.pdp_supporting_data)?.args.tableColumns
        if (supportingDataLabels) {
          supportingTableData.value = useProductStore().getSupportingData(productId, supportingDataLabels)
        } else {
          supportingTableData.value = []
        }
        fetchingRelatedProductTemplate.value = false
      }
    )

    return {
      selectedApplicationChiclet,
      onChicletClick,
      trackProductClick,
      supportingTableData,
      fetchingRelatedProductTemplate,
    }
  },
})
